import { Attachment } from "@app/models";
import { createAction, props } from "@ngrx/store";

export const openAttachmentViewPage = createAction(
  "[Attachments Preview] Open Attachment View Page",
  props<{ attachment: Attachment }>()
);
